module.exports = __webpack_public_path__ + "static/media/popular_learning_topics_2.9c102fe2.png";